import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * A reusable toast notification component for Archive/Unarchive actions using Bootstrap styles.
 *
 * Props:
 * - variant: 'archived' | 'unarchived'
 * - onClose: () => void (optional manual close callback)
 */
export default function ActionToast({ variant = 'archived', onClose, setAppear }) {
  const navigate = useNavigate();
  const isArchived = variant === 'archived';
  // auto dismiss after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose?.();
      setAppear(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const targetPath = isArchived ? '/setup/archived' : '/marketingcompliance';
  const label = isArchived ? 'View Archived Documents' : 'Go to Marketing Compliance';
  const header = isArchived ? 'Document Archived' : 'Document Restored';
  const description = isArchived
    ? 'Your document has been archived successfully! To view it, navigate to Setup and click View Archived Documents.'
    : 'Your document has been restored! You can now find it under the Marketing Compliance page.';

  const handleClose = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    onClose?.();
    setAppear(false);
  };

  const handleAction = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(targetPath);
    setAppear(false);
  };

  return (
    <AnimatePresence >
      <div
        className="position-fixed top-0 start-50 translate-middle-x p-3"
        style={{ zIndex: 1050 }}
      >
        <motion.div
          initial={{ opacity: 0, y: '-100%' }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: '-100%' }}
          transition={{ duration: 0.4 }}
        >
          <div className="toast show bg-dark " role="alert" aria-live="assertive" aria-atomic="true">
            <div className="toast-header bg-dark text-white border-secondary">
              <strong className="me-auto">{header}</strong>
              <button
                type="button"
                className="btn-close ms-2 mb-1 bg-white"
                aria-label="Close"
                onClick={handleClose}
              />
            </div>
            <div className="toast-body">
              <p className="mb-2 fw-medium text-white " style={{ fontSize: '15px' }}>{description}</p>

            </div>
            <hr className="m-0 mb-2 text-white" />
            <button
              type="button"
              className="btn btn-secondary btn-sm mb-2 ms-2 py-2 text-dark"
              onClick={handleAction}
            >
              {label}
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}
